import * as t from 'io-ts';

export const CrewMemberDynamicType = t.interface({
    fullName: t.union([t.string, t.null]),
    telephone: t.union([t.string, t.null]),
    roleName: t.union([t.string, t.null])
});

export type CrewMember = t.TypeOf<typeof CrewMemberDynamicType>;
